import actions from './actions';

const initState = {
  loading: false,
  error: null,
  allTransactions: [],
  summary: {},
};

export default function indicoreReducer(state = initState, action) {
  switch (action.type) {
    case actions.GET_ALL_TRANSACTION:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actions.GET_ALL_TRANSACTION_SUCCESS:
      return {
        ...state,
        loading: false,
        allTransactions: action.payload.data,
      };

    case actions.GET_ALL_TRANSACTION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    case actions.RESET_ALL_TRANSACTION:
      return initState;

 case actions.GET_SUCCESS_SUMMARY:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.GET_SUCCESS_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        summary: action.payload.data,
      };
    case actions.GET_SUCCESS_SUMMARY_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case actions.RESET_SUCCESS_SUMMARY:
      return {
        ...state,
        summary: null,
      };


    default:
      return state;
  }
}
